import React, { useRef, useState, useCallback } from 'react';
import Button from '@amzn/meridian/button';
import Checkbox from '@amzn/meridian/checkbox';
import Popover from '@amzn/meridian/popover';
import Column from '@amzn/meridian/column';
import Box from '@amzn/meridian/box';
import { ColDef } from 'ag-grid-community';
interface ColumnSelectorProps {
  allColumns: ColDef[];
  visibleColumns: string[];
  onToggleColumn: (columnField: string, visible: boolean) => void;
}

const ColumnSelector: React.FC<ColumnSelectorProps> = ({ allColumns, visibleColumns, onToggleColumn }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);

  const handleToggle = useCallback(() => setOpen((prev) => !prev), []);
  const handleClose = useCallback(() => setOpen(false), []);

  return (
    <>
      <Button onClick={handleToggle} ref={buttonRef} type="secondary" aria-haspopup="dialog" aria-expanded={open}>
        Columns
      </Button>

      <Popover
        anchorNode={buttonRef.current || undefined}
        open={open}
        onClose={handleClose}
        position="bottom"
        alignment="end"
      >
        <Box width={'250px'} height={'300px'} overflowY="auto">
          <Column spacing="200">
            {allColumns.map((col) => {
              const field = col.field || '';
              const headerName = col.headerName || field;
              if (!field) return null;
              return (
                <Checkbox
                  key={field}
                  checked={visibleColumns.includes(field)}
                  onChange={(checked) => onToggleColumn(field, checked)}
                >
                  {headerName}
                </Checkbox>
              );
            })}
          </Column>
        </Box>
      </Popover>
    </>
  );
};

export default React.memo(ColumnSelector);
